<template>
  <router-link
    class="workflow-folder-card"
    tag="div"
    :data-folder-id="folder.id"
    :data-collaborator-id="(folder.collaborator && folder.collaborator.id) || 1"
    :to="{
      name: 'folderDetail',
      params: {
        organizationId: $route.params.organizationId,
        folderId: folder.id,
      },
    }"
  >
    <div class="name" v-text="folder.name" />
    <div v-if="folder.contact" class="contact" v-text="folder.contact.email" />
    <div class="tags">
      <OrganizationTag
        v-for="tag in folder.tags"
        :key="`folder-tag-${folder.id}-${tag.id}`"
        :tag="tag"
      />
    </div>
    <div
      v-if="folder.collaborator"
      class="collaborator"
      v-text="folder.collaborator.email"
    />
    <div v-if="folder.displayCompletionRate" class="completion_rate">
      <v-progress-linear
        :value="folder.completionRateValue"
        color="light-blue"
        striped
        height="20"
      >
        <div
          class="completion_rate_label"
          v-text="folder.completionRateLabel"
        />
      </v-progress-linear>
    </div>
  </router-link>
</template>

<script>
import OrganizationTag from "../OrganizationTag.vue";

export default {
  name: "WorkflowFolderCard",
  components: {
    OrganizationTag,
  },
  props: {
    folder: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.workflow-folder-card {
  border: 4px;
  background-color: #f4f7ff;
  padding: 12px;
  margin-bottom: 16px;

  display: flex;
  flex-direction: column;
  gap: 4px;

  .name {
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
  }

  .contact {
    font-size: 13px;
    line-height: 18px;
  }

  .collaborator {
    font-size: 10px;
    list-style: 10px;
    text-align: right;
    color: #4f4f4f;
  }

  .tags {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 4px;
  }

  .completion_rate {
    margin-top: 8px;
    .completion_rate_label {
      font-size: 10px;
      text-align: center;
      color: #333;
    }
  }
}
</style>
